<script lang="ts">
    import vm from '@journeys/Journeys.viewmodel';
    import ScrollableContainer from '@shared/components/ScrollableContainer.vue';
    import { staticPresetsStart, staticPresetsActions, staticPresetsConditions } from './Partials/NodeStaticPresets';

    // components
    import NodePresetList from './Partials/NodePresetList.vue';

    // this is mostly for debugging, otherwise components are Anonymous
    const component = {
        name: 'Partial_NodeLists',
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const { account } = vm;
</script>

<template>
    <ScrollableContainer class="p-lg-b">
        <h2 class="h3">{{ $Resources.JourneyNodesLabel }}</h2>
        <p class="m-lg-b">{{ $Resources.JourneyNodesIntroduction }}</p>

        <!-- <div class="section-group" style="--index: 2" v-if="filtered.length > 0">
        <h3 class="title mb-sm">Account</h3>
        <NodePresetList :columns="4" :gap="8" :list="filtered" :editable="true" style="--index: 2" />
        </div> -->

        <div class="section-group" style="--index: 2">
            <h3 class="h5">{{ $Resources.NodePresetsStartLabel }}</h3>
            <NodePresetList :columns="4" :gap="8" :list="staticPresetsStart()" style="--index: 3" />
        </div>

        <div class="section-group mt-l" style="--index: 2">
            <h3 class="h5">{{ $Resources.NodePresetsActionsLabel }}</h3>
            <NodePresetList :columns="4" :gap="8" :list="staticPresetsActions()" style="--index: 3" />
        </div>

        <div class="section-group mt-l" style="--index: 2">
            <h3 class="h5">{{ $Resources.NodePresetsConditionsLabel }}</h3>
            <NodePresetList :columns="4" :gap="8" :list="staticPresetsConditions()" style="--index: 3" />
        </div>
    </ScrollableContainer>
</template>

<style></style>
